import React from 'react'
import {makeStyles} from '@material-ui/core/styles'
import curve from '../../assets/curve.svg'
import { Parallax } from 'react-parallax'

const useStyles = makeStyles((theme)=>({
    heroContainer: {
        padding: '0px 0px',
        color: '#ffffff',
        '& .react-parallax-content': {
            backgroundColor: 'rgba(0, 0, 0, 0.35)'
        },
        [theme.breakpoints.down('sm')]: {
            padding: '0px 0px',
        }
    },
    heroareaRoot: {
        height: '100vh',
        minHeight: '720px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        //[theme.breakpoints.down('sm')]: {
        //    minHeight: 'calc(100vh - 74px)',
        //}
    },
    heroTitle: {
        fontSize: '2.6rem',
        fontWeight: '500',
        textAlign: 'center',
        margin: '0px',
        lineHeight: '1em',
        marginTop: '25px',
        letterSpacing: '0.1em',
        [theme.breakpoints.down('md')]: {
            fontSize: '2.2rem'
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: '2.0rem'
        },
        [theme.breakpoints.down('xs')]: {
            fontSize: '1.8rem'
        }
    },
    heroSubTitle: {
        display: 'flex',
        flexDirection: 'row',
        fontWeight: '500',
        letterSpacing: '0.2em',
        fontSize: '1.375rem',
        '& .sub-title': {
            textAlign: 'center'
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: '1.2rem'
        }
    },
    curveLine: {
        padding: '0px 20px',
        [theme.breakpoints.down('sm')]: {
            padding: '0px 10px',
        }
    }
}))

function StaticHeroarea({heading, subHeading, image}) {
    const classes = useStyles()
    return (
        <div className={classes.heroContainer}>
            <Parallax strength={200} bgImage={image}>
                <div className={classes.heroareaRoot}>
                    <h1 className={classes.heroTitle}>{heading}</h1>
                    <div className={classes.heroSubTitle}>
                        <span className={'sub-title'}>
                            {subHeading}
                        </span>
                    </div>
                </div>
            </Parallax>
        </div>
    )
}

export default StaticHeroarea
